import axios from "axios";

// POST that rides out a brief network drop or a short host-side block (2026-10-15).
// The account-loading calls after sign-in used to fail once and leave the user
// "signed in" with no suppliers — a blank app. Retries transport failures, 5xx,
// 403 (the host's burst block) and 429; a 401 is left to the axios interceptor,
// which renews the session or ends it.
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

export const postWithRetry = async (url, body, attempts = 3) => {
  let lastError;
  for (let i = 0; i < attempts; i += 1) {
    try {
      return await axios.post(url, body);
    } catch (error) {
      lastError = error;
      const status = error?.response?.status;
      const retryable = !status || status >= 500 || status === 403 || status === 429;
      if (!retryable || i === attempts - 1) break;
      await sleep(700 * 2 ** i);
    }
  }
  throw lastError;
};
